/**
 * Sticky Spoed Element
 * Makes the "Spoed?" element stick to the bottom of the viewport
 * when scrolled out of view, and stops before reaching the footer
 */

document.addEventListener('DOMContentLoaded', function() {
    const spoedElement = document.querySelector('.spoed');
    
    if (!spoedElement) {
        return; // Exit if element doesn't exist
    }

    const footer = document.querySelector('.footer');
    
    if (!footer) {
        return; // Exit if footer doesn't exist
    }

    // Store original position - calculate after page is fully loaded
    let originalTop;
    let elementHeight;
    let isInitialized = false;
    
    // Create a placeholder to prevent layout shift
    const placeholder = document.createElement('div');
    spoedElement.parentNode.insertBefore(placeholder, spoedElement.nextSibling);
    
    function initialize() {
        // Get absolute position from top of document
        const rect = spoedElement.getBoundingClientRect();
        originalTop = rect.top + window.pageYOffset;
        elementHeight = spoedElement.offsetHeight;
        placeholder.style.height = elementHeight + 'px';
        placeholder.style.display = 'none';
        isInitialized = true;
    }
    
    // Initialize after page is fully loaded
    if (document.readyState === 'complete') {
        initialize();
    } else {
        window.addEventListener('load', initialize);
    }

    function handleScroll() {
        // Don't do anything until initialized
        if (!isInitialized) {
            return;
        }
        
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const viewportHeight = window.innerHeight;
        const footerTop = footer.offsetTop;
        const viewportBottom = scrollTop + viewportHeight;
        
        // Calculate element's current top position relative to page top
        const elementTop = originalTop;
        const elementBottom = originalTop + elementHeight;
        
        // Element should stick when:
        // The top of viewport has scrolled past the top of the element
        // (element would disappear at top of screen when scrolling down)
        const viewportPassedElement = scrollTop > elementTop;
        
        // Footer is reached when the sticky element at viewport bottom would reach footer
        const footerReached = viewportBottom >= footerTop;

        if (viewportPassedElement && !footerReached) {
            // Stick to bottom of viewport
            spoedElement.classList.add('is-sticky-bottom');
            spoedElement.classList.remove('is-at-footer');
            placeholder.style.display = 'block';
            spoedElement.style.bottom = '0';
            spoedElement.style.top = '';
        } else if (viewportPassedElement && footerReached) {
            // Stop before footer - keep fixed but push up
            spoedElement.classList.remove('is-sticky-bottom');
            spoedElement.classList.add('is-at-footer');
            placeholder.style.display = 'block';
            
            // Calculate position: distance from top of viewport to footer minus element height
            const distanceFromViewportTop = footerTop - scrollTop - elementHeight;
            spoedElement.style.top = distanceFromViewportTop + 'px';
            spoedElement.style.bottom = '';
        } else {
            // Normal position - stays in document flow
            spoedElement.classList.remove('is-sticky-bottom', 'is-at-footer');
            placeholder.style.display = 'none';
            spoedElement.style.top = '';
            spoedElement.style.bottom = '';
        }
    }

    // Throttle scroll event for better performance
    let ticking = false;
    window.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    });

    // Don't run initial check - wait for actual scroll
    // This prevents false triggering on page load
    
    // Recalculate on window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            if (!isInitialized) return;
            
            // Remove sticky state temporarily to get original position
            spoedElement.classList.remove('is-sticky-bottom', 'is-at-footer');
            placeholder.style.display = 'none';
            spoedElement.style.top = '';
            spoedElement.style.bottom = '';
            
            // Recalculate dimensions - use getBoundingClientRect for absolute position
            const rect = spoedElement.getBoundingClientRect();
            originalTop = rect.top + window.pageYOffset;
            elementHeight = spoedElement.offsetHeight;
            placeholder.style.height = elementHeight + 'px';
            
            handleScroll();
        }, 100);
    });
});
